import { Injectable, OnDestroy } from "@angular/core";

@Injectable({ providedIn: "root" })
export class MobileSafeAreaService implements OnDestroy {
  private readonly onResize = () => this.applySafeArea();

  constructor() {
    this.applySafeArea();
    window.addEventListener("resize", this.onResize);
  }

  ngOnDestroy(): void {
    window.removeEventListener("resize", this.onResize);
  }

  applySafeArea(): void {
    const topInset = this.readComputedEnvInset("safe-area-inset-top");
    const bottomInset = this.readComputedEnvInset("safe-area-inset-bottom");
    document.documentElement.style.setProperty("--capacitor-safe-top", `${topInset}px`);
    document.documentElement.style.setProperty("--capacitor-safe-bottom", `${bottomInset}px`);
  }

  private readComputedEnvInset(variableName: string): number {
    const probe = document.createElement("div");
    probe.style.position = "fixed";
    probe.style.top = "0";
    probe.style.left = "0";
    probe.style.paddingTop = `env(${variableName})`;
    probe.style.visibility = "hidden";
    document.body.appendChild(probe);
    const value = parseFloat(getComputedStyle(probe).paddingTop || "0");
    document.body.removeChild(probe);
    return Number.isFinite(value) ? value : 0;
  }
}
